import { lazy } from 'react';

import * as routePath from '../route-path';

const LoginPage = lazy(() => import('modules/auth/Login'));
const ForgotPasswordPage = lazy(() => import('modules/auth/ForgotPassword'));
// const SignUpPage = lazy(() => import('components/Pages/Auth/SignUp'));
const StaffSetPasswordPage = lazy(() =>
  import('modules/staff/Staff/SetPassword')
);

const routes = [
  {
    path: routePath.LOGIN,
    component: LoginPage,
    exact: true,
  },
  {
    path: routePath.FORGOT_PASSWORD,
    component: ForgotPasswordPage,
    exact: true,
  },
  // {
  //   path: routePath.SIGNUP,
  //   component: SignUpPage,
  //   exact: true,
  // },
  {
    path: routePath.STAFF_SET_PASSWORD,
    component: StaffSetPasswordPage,
    exact: true,
  },
];

export default routes;
